import styled, { css } from 'styled-components';

import { elevation, getElevationTransition } from "../Styles/Utils";
import { ChevronIcon } from "../Icons";

const Container = /*#__PURE__*/styled.section.withConfig({ displayName: "styles__Container", componentId: "sc-1hiax6j-0" })(["position:relative;"]);



const ItemStyles = /*#__PURE__*/css(["height:48px;display:flex;align-items:center;padding:0 16px;color:", ";"],




({ theme }) => theme.colors.Foreground);


const ItemText = /*#__PURE__*/styled.div.withConfig({ displayName: "styles__ItemText", componentId: "sc-1hiax6j-1" })(["flex:1;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;"]);






const SelectedItem = /*#__PURE__*/styled.div.withConfig({ displayName: "styles__SelectedItem", componentId: "sc-1hiax6j-2" })(["", ";border-radius:24px;border:2px solid ", ";", ""],
ItemStyles,

({ theme }) => theme.colors['Level 1'],
(props) =>
props.isMultiple &&
css(["cursor:pointer;", " &:hover{", "}&:active{", "}"],

getElevationTransition(true),

elevation(3, true),


elevation(1, true)));




const Placeholder = /*#__PURE__*/styled.div.withConfig({ displayName: "styles__Placeholder", componentId: "sc-1hiax6j-3" })(["color:", ";"],
({ theme }) => theme.colors['Level 5']);


const List = /*#__PURE__*/styled.ul.withConfig({ displayName: "styles__List", componentId: "sc-1hiax6j-4" })(["top:-3px;left:-2px;width:104%;opacity:0;visibility:hidden;position:absolute;background:", ";border-radius:24px;z-index:2;transition:all 0.2s cubic-bezier(0.4,0,1,1);margin:0;padding:0;transform:scale(0.9);transform-origin:top center;", " ", ""],






({ theme }) => theme.colors.ElementBackground,







elevation(0, false),

(props) =>
props.isOpen &&
css(["width:101%;opacity:1;visibility:visible;transition:all 0.2s cubic-bezier(0,0,0.2,1);transform:scale(1);", ""],





elevation(3, false)));



const ListElement = /*#__PURE__*/styled.li.withConfig({ displayName: "styles__ListElement", componentId: "sc-1hiax6j-5" })(["", ";cursor:pointer;&:hover{background:", ";}transition:background-color ease 0.3s;&:first-child{border-radius:20px 20px 0 0;}&:last-child{border-radius:0 0 20px 20px;}&:not(:last-child){border-bottom:2px solid ", ";}"],
ItemStyles,


({ theme }) => theme.colors['Level 1'],









({ theme }) => theme.colors['Level 1']);



const IconWrap = /*#__PURE__*/styled.div.withConfig({ displayName: "styles__IconWrap", componentId: "sc-1hiax6j-6" })(["margin-right:8px;display:flex;"]);




const Chevron = /*#__PURE__*/styled(ChevronIcon).withConfig({ displayName: "styles__Chevron", componentId: "sc-1hiax6j-7" })(["height:24px;width:24px;"]);




export { List, ListElement, Chevron, Container, SelectedItem, ItemText, Placeholder, IconWrap };